import { render, staticRenderFns } from "./rating.vue?vue&type=template&id=6b9cc557&scoped=true&"
import script from "./rating.vue?vue&type=script&lang=js&"
export * from "./rating.vue?vue&type=script&lang=js&"
import style0 from "./rating.vue?vue&type=style&index=0&id=6b9cc557&prod&scoped=true&lang=scss&"
import style1 from "./rating.vue?vue&type=style&index=1&id=6b9cc557&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9cc557",
  null
  
)

export default component.exports